import state from './panel.state'
import mutations from './panel.mutations'
import actions from './panel.actions'

export default {
  state,
  mutations,
  actions
}
